import React from 'react';
import { Flex, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from '@bettercomp/ui-components';
import { Plan, SurveySeason } from 'types';
import { PlanStatusBadge } from 'components/SurveyResultsSeason/PlanStatus';

import { SurveySeasonBadge } from './SurveySeasonBadge';
import SurveyRefreshWorkflowIllustration from './survey-refresh-workflow.svg';
import cn from './styles.module.scss';

type InProgressBannerProps = {
  surveySeason: SurveySeason;
  onContinue?: () => void;
  onClose?: () => void;
};

export function InProgressBanner({ surveySeason, onContinue, onClose }: InProgressBannerProps) {
  return (
    <Flex align="center" gap={32} className={cn.content}>
      <SurveyRefreshWorkflowIllustration aria-hidden className={cn.illustration} />
      <Flex vertical gap={8} className={cn.body}>
        <SurveySeasonBadge label="Survey Refresh Workflow" />
        <Flex align="center" gap={8}>
          <Typography.Title level={4} className={cn.title}>{surveySeason.plan?.name}</Typography.Title>
          {surveySeason.plan && (
            <PlanStatusBadge plan={surveySeason.plan as Plan} data-testid="surveySeasonDraftBadge" />
          )}
        </Flex>
        <Typography.Paragraph className={cn.description}>
          Pick up where you left off and roll into the new season.
        </Typography.Paragraph>
      </Flex>
      <Flex align="center" gap={8} className={cn.action}>
        <Button
          type="primary"
          size="large"
          onClick={onContinue}
          data-testid="surveySeasonContinueButton"
        >
          Continue
        </Button>
      </Flex>
      {onClose && (
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
          data-testid="surveySeasonCloseButton"
          aria-label="Dismiss"
          className={cn.closeButton}
        />
      )}
    </Flex>
  );
}
